import { ApolloClient, InMemoryCache } from '@apollo/client';
import { relayStylePagination } from '@apollo/client/utilities';
import { apolloLink } from '../../../shared/data/apolloClient';

const suspectDetailsApolloClient = new ApolloClient({
  link: apolloLink,
  cache: new InMemoryCache({
    typePolicies: {
      Organization: {
        fields: {
          vehicles: relayStylePagination(),
        },
      },
      Suspect: {
        fields: {
          attachments: relayStylePagination(),
          vehicles: relayStylePagination(),
        },
      },
    },
  }),
});

export default suspectDetailsApolloClient;
